// extracted by mini-css-extract-plugin
module.exports = {"box":"WeekTimeline_box__1lXGK"};